import { render } from "./AnswerCreateModal.vue?vue&type=template&id=ca806b1a&scoped=true&ts=true"
import script from "./AnswerCreateModal.vue?vue&type=script&lang=ts"
export * from "./AnswerCreateModal.vue?vue&type=script&lang=ts"

import "./AnswerCreateModal.vue?vue&type=style&index=0&id=ca806b1a&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca806b1a"]])

export default __exports__